import React, { useEffect } from 'react';

import './ModalBox.css';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

export const ModalBox = ({ media, open, handleClose }) => {
  useEffect(() => {}, []);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    maxWidth: 800,
    minWidth: 600,
    transform: 'translate(-50%, -50%)',
    width: '60vw',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        {media && (
          <div className='modal-container'>
            <div className='modal-title'>
              <a href={media.link} target='_blank' rel='noreferrer'>
                {media.headline}
              </a>
            </div>
            <div className='modal-subtitle'>
              by <span>{media.media}</span>
            </div>
            <div>{media.summary}</div>
            <div className='modal-separator' />
            <div className='modal-footer'>
              <span>Stance score:</span>
              <b>{media.y}</b>
            </div>
            <div className='modal-footer'>
              <span>Ideology:</span>
              <b>{media.ideology_label}</b>
            </div>
          </div>
        )}
      </Box>
    </Modal>
  );
};
